module.exports = __webpack_public_path__ + "static/media/groupcare_logo_ver.6e412c81.jpg";